import { Injectable } from '@angular/core';
import { filter, Observable, switchMap, take } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { AppState } from '@store/reducers';
import { IResponseSuccess } from '@core/interfaces';
import { selectMenuList, selectStore } from '@store/selectors';
import { Menu, Store as StoreModel } from '@core/models';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  menuList$: Observable<Menu[] | null>;
  store$: Observable<StoreModel | null>;

  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
  ) {
    this.menuList$ = this.store.select(selectMenuList);
    this.store$ = this.store.select(selectStore)
  }

  findAll(): Observable<IResponseSuccess<Menu>> {
    return this.store$.pipe(
      filter((store) => !!store),
      switchMap((store) => {
        return this.http.get<IResponseSuccess<Menu>>(
          `${environment.microConfiguraciones}/menus`,
          {
            params: {
              localId: store.idLocal,
            },
            headers: {
              authorization: store.apiKey,
            }
          },
        );
      }),
      take(1),
    );
  }

}
